import './index.css'

export default function Header({ text }) {
  return (
    <h4
      className="app-header"
    >
      {text}
    </h4>
  )
}
